const RESCHEDULE_FROM_APPOINTMENT_KEY = 'appointments.rescheduleFrom';

export const saveRescheduleFrom = (appointmentId: string) =>
  sessionStorage.setItem(RESCHEDULE_FROM_APPOINTMENT_KEY, appointmentId);

export const clearRescheduleFrom = () => sessionStorage.removeItem(RESCHEDULE_FROM_APPOINTMENT_KEY);
export const getRescheduleFrom = () => sessionStorage.getItem(RESCHEDULE_FROM_APPOINTMENT_KEY);
